"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9761],{

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86594);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63372);
// components/AddressAutocomplete.js







const AddressAutocomplete = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [selectedAddress, setSelectedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [getLocationLoading, setgetLocationLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, seterror] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleSelect = (address)=>{
        setSelectedAddress(address);
        // Retrieve additional details including pincode
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            placeId: address.value.place_id
        }, async (results, status)=>{
            if (status === "OK" && results[0]) {
                const pincode = extractPincodeFromResults(results[0]);
                if (!pincode && results[0].place_id) {
                    let pinnn = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://proxy.orientbell.com/getpininfobyplaceid?pin=".concat(results[0].place_id));
                    const { lat , lng  } = pinnn.data.pplaceInfo.result.geometry.location;
                    const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(lat, "&lon=").concat(lng, "&format=json"));
                    const address = response.data.address;
                    if (address && address.postcode) {
                        const pincode1 = address.postcode;
                        props.setLocationPopop(false);
                        js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("skipLocationTimeBestPrice", true, {
                            expires: 7,
                            secure: true,
                            sameSite: "Strict"
                        });
                        props.setleadpopop();
                        setTimeout(()=>{
                            props.settarrekImage(true);
                        }, 3000);
                        localStorage.setItem("pincodeSkip", true);
                        js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode1, {
                            expires: 7,
                            secure: true,
                            sameSite: "Strict"
                        });
                        (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                            pincodedetails: pincode1
                        });
                        setgetLocationLoading(false);
                        if (router.asPath.includes("/tiles")) {
                            router.reload();
                        }
                    }
                    return;
                }
                // onSelect({ ...address, pincode });
                localStorage.setItem("pincodeSkip", true, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode);
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                props.setLocationPopop(false);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("skipLocationTimeBestPrice", true, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            } else {
                console.log("Error fetching geocode data:", status);
            }
        });
    };
    const handlePincodeFetch = async ()=>{
        setgetLocationLoading(true);
        try {
            if ("geolocation" in navigator) {
                const permission = await navigator.permissions.query({
                    name: "geolocation"
                });
                if (permission.state === "granted") {
                    if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("pincode")) {
                        await retrieveGeolocation();
                    }
                } else if (permission.state === "prompt") {
                    navigator.geolocation.getCurrentPosition(async (position)=>{
                        if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("pincode")) {
                            await retrieveGeolocation();
                        }
                    }, (error)=>{
                        setgetLocationLoading(false);
                        seterror("Please enter your address / pin code for more accurate Information.");
                        console.log("Error retrieving location:", error);
                    // Handle error if needed
                    });
                } else {
                    // Permission denied or unavailable
                    setgetLocationLoading(false);
                    seterror("Please enter your address / pin code for more accurate Information.");
                    console.log("Geolocation permission denied or unavailable.");
                // Handle denied permission or unavailable state
                }
            } else {
                setgetLocationLoading(false);
                seterror("Geolocation is not supported by this browser.");
                console.log("Geolocation is not supported by this browser.");
            // Handle unsupported geolocation
            }
        } catch (error) {
            setgetLocationLoading(false);
            seterror("Error checking geolocation permission:");
            console.log("Error checking geolocation permission:", error);
        // Handle error if needed
        }
    };
    const retrieveGeolocation = async ()=>{
        try {
            const position = await new Promise((resolve, reject)=>{
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                });
            });
            if (!router.asPath.includes("/tiles")) {
                props.setLocationPopop(false);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("skipLocationTimeBestPrice", true, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                setgetLocationLoading(false);
            }
            const { latitude , longitude  } = position.coords;
            const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(latitude, "&lon=").concat(longitude, "&format=json"));
            const address = response.data.address;
            if (address && address.postcode) {
                const pincode = address.postcode;
                props.setLocationPopop(false);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("skipLocationTimeBestPrice", true, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                localStorage.setItem("pincodeSkip", true);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            }
        } catch (error) {
            console.log("Error retrieving location:", error);
            const errorMessage = error.message || "Something went wrong while retrieving your location.";
            swal(errorMessage);
        }
    };
    const extractPincodeFromResults = (result)=>{
        const postalCodeComponent = result.address_components.find((component)=>component.types.includes("postal_code"));
        return postalCodeComponent ? postalCodeComponent.short_name : "";
    };
    const renderSuggestions = (active, suggestions, onSelectSuggestion)=>{
        const filteredSuggestions = suggestions.filter((suggestion)=>{
            const hasPostalCode = suggestion.terms.some((term)=>term.types.includes("postal_code"));
            return hasPostalCode;
        });
        return filteredSuggestions.map((suggestion)=>{
            const isActive = active === suggestion.active;
            const classNames = "suggestion-item ".concat(isActive ? "active" : "");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classNames,
                onClick: ()=>onSelectSuggestion(suggestion),
                children: suggestion.description
            }, suggestion.placeId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: getLocationLoading ? "btn btn-secondary" : "btn btn-success",
                disabled: getLocationLoading,
                onClick: ()=>{
                    handlePincodeFetch();
                },
                children: getLocationLoading ? "Fetching" : "Detect Location"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                class: "location-or-bx",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "OR"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                apiKey: "AIzaSyBrmlHMs5JUON_ErXHEKk_HSd2UoLN20HQ",
                autocompletionRequest: {
                    componentRestrictions: {
                        country: [
                            "in"
                        ]
                    }
                },
                selectProps: {
                    value: selectedAddress,
                    onChange: handleSelect,
                    placeholder: "Search for your address"
                },
                renderSuggestions: renderSuggestions
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "error text-danger",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressAutocomplete);


/***/ }),

/***/ 96296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(46737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./api.services.js/others.js + 2 modules
var others = __webpack_require__(63372);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./store/useConterStore.js
var useConterStore = __webpack_require__(17360);
// EXTERNAL MODULE: ./src/components/address.js
var address = __webpack_require__(1134);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 10 modules
var Form = __webpack_require__(4492);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 16 modules
var Dropdown = __webpack_require__(81288);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./src/constants.js
var constants = __webpack_require__(24825);
// EXTERNAL MODULE: ./node_modules/react-country-flag/dist/react-country-flag.esm.js
var react_country_flag_esm = __webpack_require__(99318);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./src/components/forms/get-in-touch.jsx










/**
 * Function to upload the audio to the server.
 * @param {string} LeadID - The Lead ID to associate the audio with.
 * @param {Blob} audioBlob - The audio blob to be uploaded.
 * @param {string} recordedText - The transcribed text from the audio.
 */ const uploadAudio = async (LeadID, audioBlob, recordedText)=>{
    if (!LeadID || !audioBlob || !recordedText) {
        console.error("Missing required parameters for audio upload");
        return;
    }
    // Create a FormData object to hold the data to be sent
    const formData = new FormData();
    formData.append("audio", audioBlob, "recording.wav");
    formData.append("LeadID", LeadID);
    formData.append("Audio_Text", recordedText);
    try {
        // Make a POST request to the server with the FormData
        await axios/* default.post */.Z.post("https://obl-js.orientbell.com/uploadAudio", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    } catch (err) {
        // Log any errors that occur during the upload
        console.error("Upload error", err);
    }
};
/**
 * A Modal component for getting in touch with our tile's expert.
 * @param {Object} props
 * @param {boolean} props.TimePopup - Whether to show the 15 second popup or not.
 * @param {function} props.submitGetInTouch - Function to call when the form is submitted.
 * @param {function} props.onHide - Function to call when the modal is closed.
 */ function GetInTouchModal(param) {
    let { show , TimePopup , submitGetInTouch , onHide  } = param;
    const router = (0,next_router.useRouter)();
    const isExportPage = (0,react.useMemo)(()=>{
        return router.asPath.includes("/tile-exports") || router.asPath.includes("/download-export-catalogue");
    }, [
        router.asPath
    ]);
    const [recordedText, setRecordedText] = (0,react.useState)("");
    const [audioBlob, setAudioBlob] = (0,react.useState)(null);
    const [recording, setRecording] = (0,react.useState)(false);
    /**
   * Reference to the media recorder object.
   */ const mediaRecorderRef = (0,react.useRef)(null);
    /**
   * Reference to the audio chunks array.
   */ const audioChunksRef = (0,react.useRef)([]);
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            number: "",
            email: "",
            pincode: js_cookie/* default.get */.Z.get("pincode") || "",
            countryCode: "",
            cc: ""
        },
        validationSchema: yup_index_esm/* object */.Ry({
            name: yup_index_esm/* string */.Z_().required("Name is required").matches(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),
            number: isExportPage ? yup_index_esm/* string */.Z_().matches(/^[0-9]+$/, "Only numbers are allowed").min(6, "Invalid number").max(16, "Invalid number").required("Number is required") : yup_index_esm/* string */.Z_().required("Number is required").matches(/^[a-zA-Z0-9]+$/, "Mobile number must be alphanumeric").matches(/^[0-9]+$/, "Only numbers are allowed").length(10, "Invalid number"),
            email: yup_index_esm/* string */.Z_(),
            pincode: yup_index_esm/* string */.Z_().nullable().length(6, "Invalid pincode")
        }),
        onSubmit: (values, param)=>{
            let { resetForm , setSubmitting , setErrors  } = param;
            try {
                const label = TimePopup ? isExportPage ? "Get In Touch 15_sec_Pop-up export" : "Get In Touch 15_sec_Pop-up" : isExportPage ? "Get In Touch Tariq export" : "Get In Touch Tariq";
                submitGetInTouch(label, {
                    ...values,
                    audioBlob,
                    recordedText
                }, "GetInTouch");
                if (true) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "mkt-form-view",
                        action: "submitted",
                        popup_id: "tareeq-figurine-view"
                    });
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                setErrors({
                    general: "Something went wrong. Please try again."
                });
            } finally{
                setSubmitting(false);
                resetForm();
                if (audioBlob) {
                    uploadAudio(values.LeadID || "Get In Touch", audioBlob, recordedText);
                }
            }
        }
    });
    /**
   * Function to start recording the audio.
   */ const startRecording = async ()=>{
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        mediaRecorderRef.current = new MediaRecorder(stream);
        mediaRecorderRef.current.ondataavailable = (e)=>{
            audioChunksRef.current.push(e.data);
        };
        mediaRecorderRef.current.onstop = ()=>{
            const blob = new Blob(audioChunksRef.current, {
                type: "audio/wav"
            });
            setAudioBlob(blob);
            audioChunksRef.current = [];
        };
        mediaRecorderRef.current.start();
        setRecording(true);
        const recognition = new window.webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = false;
        recognition.lang = "en-US";
        recognition.onresult = (e)=>{
            const currentTranscript = e.results[e.results.length - 1][0].transcript;
            setRecordedText(currentTranscript);
        };
        recognition.onerror = (e)=>console.log("Speech error:", e.error);
        recognition.onend = ()=>console.log("Speech ended");
        recognition.start();
    };
    /**
   * Function to stop recording the audio.
   */ const stopRecording = ()=>{
        var ref;
        (ref = mediaRecorderRef.current) === null || ref === void 0 ? void 0 : ref.stop();
        setRecording(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
        onShow: ()=>{
            if (true) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "mkt-form-view",
                    action: "shown",
                    popup_id: "tareeq-figurine-view"
                });
            }
        },
        onHide: ()=>{
            if (true) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "mkt-form-view",
                    action: "closed",
                    popup_id: "tareeq-figurine-view"
                });
            }
            // still call the parent handler to actually hide it
            onHide();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Dialog */.Z.Dialog, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                        children: TimePopup ? "Get in touch with our tile's expert" : "Get In Touch"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ask-question-section",
                    id: "tareeq-form-view",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "expert-fig-bx",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/new-tareek.jpg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Ask Tile Expert"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Let Experts Help You In Buying Process"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                    onSubmit: formik.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    children: "Name*"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    name: "name",
                                                    type: "text",
                                                    onChange: formik.handleChange,
                                                    value: formik.values.name,
                                                    isInvalid: formik.touched.name && !!formik.errors.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    children: "Mobile*"
                                                }),
                                                isExportPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "export-page-getInTouchTariq",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                            onSelect: (code)=>{
                                                                const country = constants/* countries.find */.hW.find((c)=>c.code === code);
                                                                formik.setFieldValue("countryCode", code);
                                                                formik.setFieldValue("cc", country.cc);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                                    variant: "secondary",
                                                                    children: formik.values.countryCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                                                                countryCode: formik.values.cc,
                                                                                svg: true
                                                                            }),
                                                                            " (".concat(formik.values.countryCode, ")")
                                                                        ]
                                                                    }) : "Country Code"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Menu */.Z.Menu, {
                                                                    style: {
                                                                        maxHeight: "200px",
                                                                        overflowY: "auto"
                                                                    },
                                                                    children: constants/* countries.map */.hW.map((country, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                            eventKey: country.code,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                                                                    countryCode: country.cc,
                                                                                    svg: true
                                                                                }),
                                                                                "".concat(country.name, " (").concat(country.code, ")")
                                                                            ]
                                                                        }, index))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                            type: "number",
                                                            name: "number",
                                                            onChange: formik.handleChange,
                                                            value: formik.values.number,
                                                            isInvalid: formik.touched.number && !!formik.errors.number
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                            type: "invalid",
                                                            children: formik.errors.number
                                                        })
                                                    ]
                                                }),
                                                !isExportPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                            type: "number",
                                                            name: "number",
                                                            onChange: formik.handleChange,
                                                            value: formik.values.number,
                                                            isInvalid: formik.touched.number && !!formik.errors.number
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                            type: "invalid",
                                                            children: formik.errors.number
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isExportPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    type: "email",
                                                    name: "email",
                                                    onChange: formik.handleChange,
                                                    value: formik.values.email,
                                                    isInvalid: formik.touched.email && !!formik.errors.email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.email
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    children: "Pincode"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    type: "number",
                                                    name: "pincode",
                                                    onChange: formik.handleChange,
                                                    value: formik.values.pincode,
                                                    isInvalid: formik.touched.pincode && !!formik.errors.pincode
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.pincode
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "recording",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                onClick: recording ? stopRecording : startRecording,
                                                children: recording ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/recording.gif",
                                                            alt: "mic"
                                                        }),
                                                        " Stop Recording"
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/nic-ing.png",
                                                            alt: "mic"
                                                        }),
                                                        " Record your Audio"
                                                    ]
                                                })
                                            })
                                        }),
                                        audioBlob && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                                                controls: true,
                                                src: URL.createObjectURL(audioBlob)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "submit",
                                            disabled: formik.isSubmitting,
                                            style: {
                                                width: "100%"
                                            },
                                            children: formik.isSubmitting ? "Submitting..." : "Submit"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/flatpickr/dist/themes/airbnb.css
var airbnb = __webpack_require__(63877);
// EXTERNAL MODULE: ./node_modules/react-flatpickr/build/react-flatpickr.js + 7 modules
var react_flatpickr = __webpack_require__(6988);
;// CONCATENATED MODULE: ./src/components/forms/premium-callback.jsx













const timeSlots = [
    {
        label: "9:00 AM",
        value: 9
    },
    {
        label: "9:30 AM",
        value: 9
    },
    {
        label: "10:00 AM",
        value: 10
    },
    {
        label: "10:30 AM",
        value: 10
    },
    {
        label: "11:00 AM",
        value: 11
    },
    {
        label: "11:30 AM",
        value: 11
    },
    {
        label: "12:00 PM",
        value: 12
    },
    {
        label: "12:30 PM",
        value: 12
    },
    {
        label: "1:00 PM",
        value: 13
    },
    {
        label: "1:30 PM",
        value: 13
    },
    {
        label: "2:00 PM",
        value: 14
    },
    {
        label: "2:30 PM",
        value: 14
    },
    {
        label: "3:00 PM",
        value: 15
    },
    {
        label: "3:30 PM",
        value: 15
    },
    {
        label: "4:00 PM",
        value: 16
    },
    {
        label: "4:30 PM",
        value: 16
    },
    {
        label: "5:00 PM",
        value: 17
    },
    {
        label: "5:30 PM",
        value: 17
    },
    {
        label: "6:00 PM",
        value: 18
    },
    {
        label: "6:30 PM",
        value: 18
    },
    {
        label: "7:00 PM",
        value: 19
    },
    {
        label: "7:30 PM",
        value: 19
    },
    {
        label: "8:00 PM",
        value: 20
    }
];
function ProfessionalDesignConsultationModal() {
    const { premiumForm , setPremiumForm , sourceId  } = (0,useConterStore/* useCounterStore */.A)();
    const [hours, setHours] = (0,react.useState)([
        "Select Date First"
    ]);
    // inside component
    (0,react.useEffect)(()=>{
        if (premiumForm) {
            // 🔹 Modal just opened → fire "shown"
            if (true) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "mkt-form-view",
                    action: "shown",
                    popup_id: "book-a-consultation"
                });
            }
        }
    }, [
        premiumForm
    ]);
    const handleClose = ()=>{
        setPremiumForm(false);
        formik.resetForm();
        setHours([
            "Select Date First"
        ]);
        // 🔹 Modal closed → fire "closed"
        if (true) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "mkt-form-view",
                action: "closed",
                popup_id: "book-a-consultation"
            });
        }
    };
    const validationSchema = yup_index_esm/* object */.Ry({
        name: yup_index_esm/* string */.Z_().required("Name is required").matches(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),
        phone: yup_index_esm/* string */.Z_().length(10, "Must be 10 digits").matches(/^\d+$/, "Must be numeric").required("Mobile number is required"),
        email: yup_index_esm/* string */.Z_().required("Email is required").email("Invalid Email format"),
        pincode: yup_index_esm/* string */.Z_().length(6, "Invalid pincode").required("Pincode is required"),
        countryCode: yup_index_esm/* string */.Z_().nullable(),
        cc: yup_index_esm/* string */.Z_().nullable(),
        date: yup_index_esm/* mixed */.nK().required("Date is required").test("is-valid-date", "Please select a valid date", function(value) {
            if (!value) return false;
            const date1 = value instanceof Date ? value : new Date(value);
            return date1 instanceof Date && !isNaN(date1.getTime());
        }).test("is-future-date", "Date must be today or later", function(value) {
            if (!value) return false;
            const date1 = value instanceof Date ? value : new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date1 >= today;
        }),
        timeSlot: yup_index_esm/* string */.Z_().required("Time slot is required")
    });
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            phone: "",
            email: "",
            pincode: "",
            countryCode: "",
            cc: "",
            date: "",
            timeSlot: ""
        },
        validationSchema,
        onSubmit: async (values, param)=>{
            let { resetForm , setSubmitting  } = param;
            try {
                const response = await (0,others/* getIntouch */.JJ)({
                    ...values,
                    call_id: sourceId !== null && sourceId !== void 0 ? sourceId : "book-an-appointment"
                });
                if ((response === null || response === void 0 ? void 0 : response.name) && (response === null || response === void 0 ? void 0 : response.name) === "ApolloError") {
                    throw new Error(response.message);
                }
                sweetalert_min_default()("Consultation Confirmed Successfully!", "Our experts will contact you soon.", "success");
                // 🔹 Submission success → fire "submitted"
                if (true) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "mkt-form-view",
                        action: "submitted",
                        popup_id: "book-a-consultation"
                    });
                }
                resetForm();
                setPremiumForm(false);
            } catch (error) {
                console.error("Error submitting form:", error);
                sweetalert_min_default()("Error", "Something went wrong. Please try again later.", "error");
            } finally{
                setHours([
                    "Select Date First"
                ]);
                setSubmitting(false);
            }
        }
    });
    const handleDateChange = async (e)=>{
        try {
            setHours([
                "Loading..."
            ]);
            const date1 = new Date(e[0]);
            formik.setFieldValue("date", date1);
            // add cache for time slots so that we don't hit the API every time
            // Fetch available time slots for the selected date
            const response = await axios/* default.get */.Z.get("https://proxy.orientbell.com/get/timeslots?date=".concat(date1.toISOString()));
            setHours(response.data.timeslots);
        } catch (error) {
            // if date is today, filter out past hours
            if (new Date().setHours(0, 0, 0, 0) === new Date(date).setHours(0, 0, 0, 0)) {
                setHours(timeSlots.filter((slot)=>+slot.value > +new Date().getHours()).map((slot)=>slot.label));
            }
            // if date is in the future
            if (new Date().setHours(0, 0, 0, 0) < new Date(date).setHours(0, 0, 0, 0)) setHours(timeSlots.map((slot)=>slot.label));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: premiumForm,
        onHide: handleClose,
        className: "consultation-popup",
        centered: true,
        size: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                closeButton: true,
                style: {
                    backgroundColor: "#fff"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                    children: "Book a Consultation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "consul-pl-row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "consul-pl-col left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mb-0",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Making tile buying journey easy with expert advice"
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                        onSubmit: formik.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    name: "name",
                                                    placeholder: "Full Name*",
                                                    value: formik.values.name,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.name && formik.errors.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.name
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    type: "text",
                                                    name: "phone",
                                                    placeholder: "Mobile Number*",
                                                    value: formik.values.phone,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.phone && formik.errors.phone
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.phone
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    type: "email",
                                                    name: "email",
                                                    placeholder: "Email",
                                                    value: formik.values.email,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.email && formik.errors.email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.email
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    type: "number",
                                                    name: "pincode",
                                                    placeholder: "Pincode*",
                                                    value: formik.values.pincode,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.pincode && formik.errors.pincode
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.pincode
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flatpickr/* default */.Z, {
                                                    options: {
                                                        minDate: "today",
                                                        dateFormat: "Y-m-d",
                                                        disableMobile: true,
                                                        locale: "en"
                                                    },
                                                    name: "date",
                                                    placeholder: "Select Date*",
                                                    className: "form-control",
                                                    value: formik.values.date,
                                                    onChange: handleDateChange
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.date
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                                    name: "timeSlot",
                                                    value: formik.values.timeSlot,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.timeSlot && formik.errors.timeSlot,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "",
                                                            children: "Pick a Slot"
                                                        }),
                                                        hours.map((slot, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: slot === "Select Date First" ? "" : slot,
                                                                children: slot
                                                            }, index))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                                    type: "invalid",
                                                    children: formik.errors.timeSlot
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                style: {
                                    fontSize: "11px",
                                    color: "#6c757d",
                                    lineHeight: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        style: {
                                            fontSize: "11px",
                                            color: "#000",
                                            lineHeight: "16px"
                                        },
                                        children: [
                                            "Note:",
                                            " "
                                        ]
                                    }),
                                    "Please ensure a stable internet connection and be available at your chosen time."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                onClick: formik.handleSubmit,
                                variant: "warning",
                                className: "w-100",
                                disabled: formik.isSubmitting,
                                style: {
                                    borderRadius: "99px",
                                    color: "#fff"
                                },
                                children: formik.isSubmitting ? "Submitting..." : "Book Now"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/forms/get-in-touch-pop-up.jsx





function GetInTouchPopUp(param) {
    let { handleClick  } = param;
    const { premiumForm , setPremiumForm , setSourceId  } = (0,useConterStore/* useCounterStore */.A)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "premium-callback-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    fontSize: "20px",
                    color: "#FFF8E1"
                },
                className: "premium-callback-title",
                children: "Book a Consultation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    lineHeight: "17px",
                    fontSize: "13.5px",
                    color: "#FFF8E1",
                    margin: "4px 0 12px"
                },
                children: "Get personalized expert advice tailored to your space"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                style: {
                    width: "100%",
                    backgroundColor: "#FFF8E1",
                    color: "#d9a520ff",
                    border: "1px solid #FFF8E1",
                    borderRadius: "14px",
                    fontWeight: "bold"
                },
                onClick: ()=>{
                    setSourceId("book-an-appointment-floater"); // Set sourceId when button is clicked so we know where the user came from
                    setPremiumForm(!premiumForm);
                    handleClick();
                },
                children: "Schedule a Call"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalDesignConsultationModal, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/forms/request-callback.jsx









function RequestCallbackForm() {
    const router = (0,next_router.useRouter)();
    const isExport = router.asPath.includes("/tile-exports") || router.asPath.includes("/download-export-catalogue");
    // Validation schema
    const validationSchema = yup_index_esm/* object */.Ry().shape({
        name: yup_index_esm/* string */.Z_().required("Name is required").matches(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),
        number: yup_index_esm/* string */.Z_().length(10, "Mobile number must be 10 digits").matches(/^\d+$/, "Mobile number must be numeric").required("Mobile number is required"),
        email: isExport ? yup_index_esm/* string */.Z_().email("Invalid Email format").required("Email is required") : yup_index_esm/* string */.Z_().nullable(),
        pincode: !isExport ? yup_index_esm/* string */.Z_().nullable().length(6, "Invalid Pincode") : yup_index_esm/* string */.Z_().nullable(),
        countryCode: isExport ? yup_index_esm/* string */.Z_().required("Please select a country code") : yup_index_esm/* string */.Z_(),
        cc: isExport ? yup_index_esm/* string */.Z_().required("Missing country flag") : yup_index_esm/* string */.Z_()
    });
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            number: "",
            email: "",
            pincode: js_cookie/* default.get */.Z.get("pincode") || "",
            countryCode: "",
            cc: ""
        },
        validationSchema,
        onSubmit: async (values, param)=>{
            let { setSubmitting , setErrors , resetForm  } = param;
            try {
                const response = await (0,others/* requestCallback */.mq)({
                    name: values.name,
                    phone: values.number,
                    pincode: values.pincode,
                    email: values.email
                });
                if (response === null || response === void 0 ? void 0 : response.message) {
                    localStorage.setItem("leadfilled", true);
                    swal(response === null || response === void 0 ? void 0 : response.message);
                } else {
                    var ref, ref1;
                    (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.request_callback) === null || ref1 === void 0 ? void 0 : ref1.msg) ? swal("Success", "Your details have been submitted!", "success") : swal("Error", "Something went wrong. Please try again later.", "error");
                }
            } catch (error) {
                console.error("Submission error", error);
                setErrors({
                    general: "Something went wrong. Please try again."
                });
            } finally{
                resetForm();
                setSubmitting(false);
            }
        }
    });
    const handleCountrySelect = (code)=>{
        const country = constants/* countries.find */.hW.find((c)=>c.code === code);
        if (country) {
            formik.setFieldValue("countryCode", country.code);
            formik.setFieldValue("cc", country.cc);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "flex-class",
        onSubmit: formik.handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        name: "name",
                        value: formik.values.name,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        placeholder: "Name",
                        className: "input-bx"
                    }),
                    formik.touched.name && formik.errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger",
                        children: formik.errors.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    isExport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                onSelect: handleCountrySelect,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                                        variant: "secondary",
                                        id: "dropdown-basic",
                                        children: formik.values.countryCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                                    countryCode: formik.values.cc,
                                                    svg: true
                                                }),
                                                " (".concat(formik.values.countryCode, ")")
                                            ]
                                        }) : "Country"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Menu */.Z.Menu, {
                                        style: {
                                            maxHeight: "200px",
                                            overflowY: "auto"
                                        },
                                        children: constants/* countries.map */.hW.map((country, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                eventKey: country.code,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                                            countryCode: country.cc,
                                                            svg: true
                                                        }),
                                                        "".concat(country.name, " (").concat(country.code, ")")
                                                    ]
                                                })
                                            }, index))
                                    })
                                ]
                            }),
                            formik.touched.countryCode && formik.errors.countryCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: formik.errors.countryCode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "number",
                        name: "number",
                        value: formik.values.number,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        placeholder: "Mobile Number",
                        className: "input-bx"
                    }),
                    formik.touched.number && formik.errors.number && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger",
                        children: formik.errors.number
                    })
                ]
            }),
            isExport ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "email",
                        name: "email",
                        value: formik.values.email,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        placeholder: "Email",
                        className: "input-bx"
                    }),
                    formik.touched.email && formik.errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger",
                        children: formik.errors.email
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "number",
                        name: "pincode",
                        value: formik.values.pincode,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        placeholder: "Pincode (Optional)",
                        className: "input-bx"
                    }),
                    formik.touched.pincode && formik.errors.pincode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger",
                        children: formik.errors.pincode
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-group button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "ft-submit-btn",
                    type: "submit",
                    disabled: formik.isSubmitting,
                    children: formik.isSubmitting ? "Submitting" : "Submit"
                })
            }),
            formik.errors.general && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "error text-danger",
                children: formik.errors.general
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/footer/index.js















const Footer = (props)=>{
    const router = (0,next_router.useRouter)();
    const isAdhesivesPage = router.asPath.includes("/masterbond-tile-adhesive");
    const { sidePromptModal , setSidePromptModal , _hasHydrated  } = (0,useConterStore/* useCounterStore */.A)();
    const [TimePopup, setTimePopup] = (0,react.useState)(false);
    const [getInTouch, setGetInTouch] = (0,react.useState)(false);
    const [tarrekImage, settarrekImage] = (0,react.useState)(false);
    const [LocationPopop, setLocationPopop] = (0,react.useState)(js_cookie/* default.get */.Z.get("skipLocationTimeBestPrice") ? false : true);
    const [timeOutIDS, settimeOutIDS] = (0,react.useState)([]);
    const [isClassToggled, setIsClassToggled] = (0,react.useState)(Array(15).fill(false));
    const toggleClass = (index)=>{
        const updatedStates = [
            ...isClassToggled
        ];
        updatedStates[index] = !updatedStates[index];
        setIsClassToggled(updatedStates);
    };
    const [touch, setTouch] = (0,react.useState)({
        name: "",
        number: "",
        pincode: js_cookie/* default.get */.Z.get("pincode"),
        countryCode: "",
        error: "",
        loading: false,
        cc: "",
        email: ""
    });
    const shouldShowModal = _hasHydrated ? sidePromptModal : false;
    /**
   * submitGetInTouch function is used to send the form data to the server and
   * store the lead in the database.
   * @param {string} subsource - Source of the lead (e.g. GetInTouch, GetInTouchPopUp)
   * @param {object} payload - Form data
   * @param {string} formType - Type of the form (GetInTouch or GetInTouchPopUp)
   */ const submitGetInTouch = async function(subsource) {
        let payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, formType = arguments.length > 2 ? arguments[2] : void 0;
        try {
            var ref, ref1;
            let response = await (0,others/* getIntouch */.JJ)({
                name: payload.name,
                phone: payload.number,
                pincode: payload.pincode,
                email: payload.email,
                call_id: subsource
            });
            if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.get_in_touch) === null || ref1 === void 0 ? void 0 : ref1.lead_id) {
                var ref2, ref3;
                localStorage.setItem("leadfilled", true);
                formType === "GetInTouch" && uploadAudio(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.get_in_touch) === null || ref3 === void 0 ? void 0 : ref3.lead_id, payload.audioBlob, payload.recordedText);
                handleClick();
                setGetInTouch(false);
                settarrekImage(false);
                localStorage.setItem("TarikClosed", true);
                sweetalert_min_default()("Success", "Your details have been submitted!", "success");
            } else throw new Error("Server Error");
        } catch (error) {
            console.error("Error submitting form:", error);
            sweetalert_min_default()("Error", "Something went wrong. Please try again later.", "error");
            throw error;
        }
    };
    const handleClick = ()=>{
        setSidePromptModal(!sidePromptModal);
        timeOutIDS.forEach((id)=>clearTimeout(id));
    };
    let setleadpopop = ()=>{
        const startTimeString = localStorage.getItem("startTime");
        let startTime = startTimeString && new Date(startTimeString).toLocaleDateString() == new Date().toLocaleDateString() ? new Date(startTimeString) : new Date();
        const elapsedTime = new Date() - startTime;
        let arrr = [];
        // if (localStorage.getItem("leadSkiped")) return;
        if (elapsedTime < 30000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 30000 - elapsedTime));
        } else if (elapsedTime < 60000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 60000 - elapsedTime));
        } else if (elapsedTime < 120000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 120000 - elapsedTime));
        } else if (elapsedTime < 300000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 300000 - elapsedTime));
        }
        settimeOutIDS(arrr);
        localStorage.setItem("startTime", startTime.toString());
    };
    const popoptarek = ()=>{
        if (document.referrer) {
            const referrerURL = new URL(document.referrer);
            if (referrerURL.hostname === window.location.hostname) {} else {
                setTimeout(()=>{
                    settarrekImage(true);
                }, 90000);
            }
        } else {
            setTimeout(()=>{
                settarrekImage(true);
            }, 90000);
        }
    };
    (0,react.useEffect)(()=>{
        if (js_cookie/* default.get */.Z.get("skipLocationTimeBestPrice") === true) setLocationPopop(false);
    }, [
        js_cookie/* default.get */.Z.get("skipLocationTimeBestPrice")
    ]);
    (0,react.useEffect)(()=>{
        if (!js_cookie/* default.get */.Z.get("skipLocation") && !js_cookie/* default.get */.Z.get("pincode") && (props === null || props === void 0 ? void 0 : props.displayLocationPopop)) {
        // setLocationPopop(true);
        } else {
            setleadpopop();
            popoptarek();
        }
        const handleScroll = ()=>{
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;
            // Check if the scroll position is greater than or equal to 1000px
            if (scrollPosition >= 1000 && !localStorage.getItem("schrollSkip")) {
            // setSidePromptModal(true);
            }
        };
        // Attach the event listener when the component mounts
        // window.addEventListener('scroll', handleScroll);
        // Clean up the event listener when the component unmounts
        return ()=>{
        // clearTimeout(alertAfter15Sec);
        // clearTimeout(alertAfter1Min);
        // clearTimeout(alertAfter2Min);
        // clearTimeout(alertAfter5Min)
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: shouldShowModal ? "right_sidebar_form active" : "right_sidebar_form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchPopUp, {
                        handleClick: handleClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "getintouch_siadebar",
                        onClick: handleClick,
                        style: {
                            background: "linear-gradient(45deg, hsl(43, 74%, 49%), hsl(48, 100%, 67%), hsl(16, 100%, 59%))"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "foot-icon-bx",
                                children: shouldShowModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/black-cross.png",
                                    alt: "cross"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://images.orientbell.com/media/premuimFormImg.png",
                                    alt: "get in touch"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Consult Us"
                            })
                        ]
                    })
                ]
            }),
            router.asPath == "/tile-exports" || router.asPath == "/download-export-catalogue" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile_view_footericon",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        class: "foot-info-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "ttel:+91-9599770470",
                                    "aria-level": "phone",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaPhone */.I7T, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        class: "foot-info-col",
                        id: "Whatsapp_button_mobile_footer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://wa.me/919599770470?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaWhatsapp */.xpo, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Whatsapp"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile_view_footericon",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        class: "foot-info-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:1800 208 1015",
                                    "aria-level": "phone",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaPhone */.I7T, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        class: "foot-info-col",
                        id: "Whatsapp_button_mobile_footer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaWhatsapp */.xpo, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Whatsapp"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                class: "mobile-foot-category-row",
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        class: "foot-info-col",
                        id: "Store_locator_mobile_footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://www.orientbell.com/store-locator",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "18",
                                    height: "17",
                                    viewBox: "0 0 18 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M17.0052 0.981934V2.99216H1.0169V0.981934H17.0052ZM17.987 10.9863H17.0052V16.9703H14.995V10.9863H11.0213V16.9703H1.0169V10.9863H0.0351562V8.9761L1.0169 3.9739H17.0052L17.987 8.9761V10.9863ZM9.01106 14.96V10.9863H3.02712V14.96H9.01106Z",
                                        fill: "#BFBFBF"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Stores"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        class: "foot-info-col",
                        id: "Catalogue_button_mobile_footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://www.orientbell.com/download-catalogue",
                            "aria-label": "category",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "16",
                                    height: "18",
                                    viewBox: "0 0 16 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M0.414062 14.8092C0.414063 15.4723 0.677455 16.1082 1.1463 16.577C1.61514 17.0459 2.25102 17.3092 2.91406 17.3092H12.9141C13.5771 17.3092 14.213 17.0459 14.6818 16.577C15.1507 16.1082 15.4141 15.4723 15.4141 14.8092V6.33258C15.4137 5.66988 15.1502 5.03444 14.6816 4.56591L11.4916 1.37424C11.0227 0.905677 10.3869 0.642499 9.72406 0.642578H2.91406C2.25102 0.642578 1.61514 0.90597 1.1463 1.37481C0.677455 1.84365 0.414063 2.47954 0.414062 3.14258V14.8092ZM8.7474 8.97591C8.7474 8.7549 8.6596 8.54294 8.50332 8.38666C8.34704 8.23038 8.13508 8.14258 7.91406 8.14258C7.69305 8.14258 7.48109 8.23038 7.32481 8.38666C7.16853 8.54294 7.08073 8.7549 7.08073 8.97591V11.9642L6.00323 10.8867C5.84606 10.7349 5.63556 10.651 5.41706 10.6529C5.19856 10.6547 4.98955 10.7424 4.83505 10.8969C4.68054 11.0514 4.5929 11.2604 4.591 11.4789C4.5891 11.6974 4.6731 11.9079 4.8249 12.0651L7.3249 14.5651C7.48117 14.7213 7.69309 14.8091 7.91406 14.8091C8.13503 14.8091 8.34696 14.7213 8.50323 14.5651L11.0032 12.0651C11.155 11.9079 11.239 11.6974 11.2371 11.4789C11.2352 11.2604 11.1476 11.0514 10.9931 10.8969C10.8386 10.7424 10.6296 10.6547 10.4111 10.6529C10.1926 10.651 9.98206 10.7349 9.8249 10.8867L8.7474 11.9642V8.97591Z",
                                        fill: "#BFBFBF"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Catalogue"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "review-Catalouge",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-catalog-row",
                        children: router.asPath.includes("/tile-exports") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/download-export-catalogue"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/brouchure.png",
                                    alt: "Image"
                                }),
                                " DOWNLOAD CATALOGUE"
                            ]
                        }) : isAdhesivesPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>{
                                const link = document.createElement("a");
                                link.href = "/masterbond-booklet.pdf"; // path in the public folder
                                link.download = "OBL Maserbond Booklet.pdf"; // filename when downloaded
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/brouchure.png",
                                    alt: "Image"
                                }),
                                " DOWNLOAD BOOKLET"
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/download-catalogue"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/brouchure.png",
                                    alt: "Image"
                                }),
                                " DOWNLOAD CATALOGUE"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fromUs-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ft-fromUs-row flex-class",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fr-Title",
                                children: "Get Personalized Help Choosing Tiles for Your Space"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "us-form-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestCallbackForm, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footer-main",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "footer-top flex-class",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[0] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(0),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/floor-tiles",
                                                                children: "Floor Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/wall-tiles",
                                                                children: "Wall Tiles"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    class: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: isClassToggled[16] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(16),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: "Locations"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/delhi",
                                                                        children: "Delhi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/mumbai",
                                                                        children: "Mumbai"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/bangalore",
                                                                        children: "Bengaluru"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/darjeeling",
                                                                        children: "Darjeeling"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/alipurduar",
                                                                        children: "Alipurduar"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/jangipur",
                                                                        children: "Jangipur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/raiganj",
                                                                        children: "Raiganj"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/hyderabad",
                                                                        children: "Hyderabad"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/chennai",
                                                                        children: "Chennai"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/kolkata",
                                                                        children: "Kolkata"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/lucknow",
                                                                        children: "Lucknow"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/pune",
                                                                        children: "Pune"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/bhopal",
                                                                        children: "Bhopal"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/jabalpur",
                                                                        children: "Jabalpur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/indore",
                                                                        children: "Indore"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/nagpur",
                                                                        children: "Nagpur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/coimbatore",
                                                                        children: "Coimbatore"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/patna",
                                                                        children: "Patna"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/ernakulam",
                                                                        children: "Ernakulam"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/narnaul",
                                                                        children: "Narnaul"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/mahendragarh",
                                                                        children: "Mahendragarh"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/sohna",
                                                                        children: "Sohna"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/nuh",
                                                                        children: "Nuh"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/noida",
                                                                        children: "Noida"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/gurugram",
                                                                        children: "Gurugram"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/pataudi",
                                                                        children: "Pataudi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/bhiwadi",
                                                                        children: "Bhiwadi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/manesar",
                                                                        children: "Manesar"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/dharuhera",
                                                                        children: "Dharuhera"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/farukhnagar",
                                                                        children: "Farukhnagar"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[1] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(1),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Area"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bathroom-tiles",
                                                                children: "Bathroom Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles",
                                                                children: "Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/parking-tiles",
                                                                children: "Parking Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/elevation-tiles",
                                                                children: "Elevation Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bedroom-tiles",
                                                                children: "Bedroom Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/outdoor-tiles",
                                                                children: "Outdoor Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/terrace-tiles",
                                                                children: "Terrace Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/living-room-tiles",
                                                                children: "Living Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/balcony-tiles",
                                                                children: "Balcony Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/swimming-pool-tiles",
                                                                children: "Swimming Pool Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/porch-tiles",
                                                                children: "Porch Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/office-tiles",
                                                                children: "Office Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pathway-tiles",
                                                                children: "Pathway Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dining-room-tiles",
                                                                children: "Dining Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/commercial-tiles",
                                                                children: "Commercial Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bar-tiles",
                                                                children: "Bar Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/restaurant-tiles",
                                                                children: "Restaurant Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/hospital-tiles",
                                                                children: "Hospital Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/accent-tiles",
                                                                children: "Accent Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/automotive-tiles",
                                                                children: "Automotive Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/school-tiles",
                                                                children: "School Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/high-traffic-tiles",
                                                                children: "High Traffic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/step-stairs-tiles",
                                                                children: "Stairs Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pooja-room-tiles",
                                                                children: "Pooja Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/large-tiles",
                                                                children: "Large Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/slab-tiles",
                                                                children: "Slab Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/tile-collection/gvt-anti-skid-inspire-safegrip",
                                                                children: "GVT Anti Skid"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/white-kitchen-tiles",
                                                                children: "White Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/blue-kitchen-tiles",
                                                                children: "Blue Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/green-kitchen-tiles",
                                                                children: "Green Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/black-kitchen-tiles",
                                                                children: "Black Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dolphin-tiles",
                                                                children: "Dolphin Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[2] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(2),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Design"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/3d-tiles",
                                                                children: "3d Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/wooden-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Wooden Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/marble-tiles",
                                                                children: "Marble Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/texture-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Texture Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/mosaic-tiles",
                                                                children: "Mosaic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/granite-tiles",
                                                                children: "Granite Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/stone-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Stone Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pattern-tiles",
                                                                children: "Pattern Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/cement-tiles",
                                                                children: "Cement Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/flower-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Flower Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/travertine-tiles",
                                                                children: "Travertine Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/slate-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Slate Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/statuario-tiles",
                                                                children: "Statuario Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/plain-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Plain Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/onyx-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Onyx Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/metallic-tiles",
                                                                children: "Metallic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bottochino-tiles",
                                                                children: "Bottochino Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/book-match-tiles",
                                                                children: "Book Match Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/geometric-tiles",
                                                                children: "Geometric Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/carrara-tiles",
                                                                children: "Carrara Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/abstract-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Abstract Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/monochrome-tiles",
                                                                children: "Monochrome Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/stylized-tiles",
                                                                children: "Stylized Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/brick-tiles",
                                                                children: "Brick Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/hexagonal-tiles",
                                                                children: "Hexagonal Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/limestone-tiles",
                                                                children: "Limestone Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/wooden-plank-tiles",
                                                                children: "Plank Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[3] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(3),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Type"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles",
                                                                children: "Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/ceramic-tiles",
                                                                children: "Ceramic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/porcelain-tiles",
                                                                children: "Porcelain Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/designer-tiles",
                                                                children: "Designer Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/anti-skid-tiles",
                                                                children: "Anti Skid Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/digital-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Digital Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/double-charge-tiles",
                                                                children: "Double Charge Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/gvt-tiles",
                                                                children: "GVT Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/cool-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Cool Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/highlighter-tiles",
                                                                children: "Highlighter Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/pgvt-tiles ",
                                                                children: [
                                                                    "PGVT Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/full-body-vitrified-tiles",
                                                                children: "Full Body Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/polished-vitrified-tiles",
                                                                children: [
                                                                    "Polished Vitrified Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/germ-free-tiles",
                                                                children: "Germ Free Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/dgvt-tiles",
                                                                children: "DGVT Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/forever-tiles",
                                                                children: "Scratch Free Tile(Forever Tile)"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/digital-glazed-vitrified-tiles",
                                                                children: "Double Glazed Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/stain-resistant-tiles",
                                                                children: "Stain Resistant Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/nano-tiles",
                                                                children: "Nano Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/non-digital-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Non Digital Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/anti-static-tiles",
                                                                children: "Anti Static Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/carving-tiles",
                                                                children: "Carving Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/gvt-endless-tiles",
                                                                children: "GVT Endless Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[4] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(4),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Colour"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/terracotta-tiles",
                                                                children: "Terracotta Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/white-tiles",
                                                                children: [
                                                                    " ",
                                                                    "White Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/black-tiles",
                                                                children: "Black Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/grey-tiles",
                                                                children: "Grey Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/chequered-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Chequered Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/blue-tiles",
                                                                children: "Blue Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/red-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Red Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/green-tiles",
                                                                children: "Green Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/beige-tiles",
                                                                children: "Beige Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/ivory-tiles",
                                                                children: "Ivory Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/yellow-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Yellow Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/cream-tiles",
                                                                children: "Cream Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pink-tiles",
                                                                children: "Pink Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/light-tiles",
                                                                children: "Light Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dark-tiles",
                                                                children: "Dark Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/purple-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Purple Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/multi-colour-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Multi Colour Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/wenge-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Wenge Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/brown-tiles",
                                                                children: "Brown Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/sandune-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Sandune Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/black-and-white-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Black and White Tiles"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[5] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(5),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Size"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/2x2-tiles",
                                                                children: "600X600 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/2x4-tiles",
                                                                children: "600X1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/1x1-tiles",
                                                                children: "300X300 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/300x600-tiles",
                                                                children: "300x600 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/395x395-tiles",
                                                                children: "395x395 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/300x450-tiles",
                                                                children: "300x450 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/200x1200-tiles",
                                                                children: "200x1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/800x800-tiles",
                                                                children: "800x800 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/inspire-xl-1200x1800",
                                                                children: "800x1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/800x1600-tiles",
                                                                children: [
                                                                    " ",
                                                                    "800x1600 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/granalt-tiles",
                                                                children: [
                                                                    " ",
                                                                    "800x2400 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/145x600-tiles",
                                                                children: [
                                                                    " ",
                                                                    "145x600 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/195x1200-tiles",
                                                                children: [
                                                                    " ",
                                                                    "195x1200 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/295x295-tiles",
                                                                children: "295x295 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/200x300-tiles",
                                                                children: [
                                                                    " ",
                                                                    "200x300 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/250x375-tiles",
                                                                children: [
                                                                    " ",
                                                                    "250x375 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/400x400-tiles",
                                                                children: [
                                                                    " ",
                                                                    "400x400 mm Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/1000x1000-tiles",
                                                                children: "1000x1000 mm Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[6] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(6),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Tiles by Finish"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/matte-finish-tiles",
                                                                children: "Matte Finish Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/glossy-tiles",
                                                                children: "Glossy Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/sugar-finish-tiles",
                                                                children: "Sugar Finish Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/super-glossy-tiles",
                                                                children: "Super Glossy Tiles"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: isClassToggled[7] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(7),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: "Tiles Collection"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/sparkle",
                                                                        children: "Sparkle Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/estilo",
                                                                        children: "Estilo Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/ft-autumn2020",
                                                                        children: "FT Autumn 2020 Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/sahara",
                                                                        children: "Sahara Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/rhino-series-pavers-tiles",
                                                                        children: "Rhino Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/duazzle",
                                                                        children: "Duazzle Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/inspire",
                                                                        children: "Inspire Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/hd-p-elevation",
                                                                        children: "HD-P Elevation Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/inspire-planks",
                                                                        children: "Inspire Planks Tiles Collection"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: isClassToggled[15] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(15),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: "Tools"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/tile-calculator"),
                                                                        children: "Tile Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/area-conversion-calculator"),
                                                                        children: "Area Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/paint-calculator"),
                                                                        children: "Paint Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/construction-cost-calculator"),
                                                                        children: "Cost Estimator"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "footer-top ft-bottom flex-class",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[8] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(8),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/about-us",
                                                                children: "Who are we?"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/investor",
                                                                children: "Investors Relation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/career",
                                                                children: "Careers"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/press-release",
                                                                children: "Media"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/sustainability",
                                                                children: "Sustainability"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[9] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(9),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Useful links"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "smooth-check 12",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/contact-us",
                                                                children: "Contact us"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/faq",
                                                                children: "FAQ"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/store-locator",
                                                                children: "Store Locator"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/site-map",
                                                                children: "Sitemap"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/signature-company-showrooms",
                                                                children: "Signature Company Showrooms"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://stores.orientbell.com",
                                                                children: "Orientbell Tiles Boutique Locator"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[10] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(10),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Solutions for"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tile-selector",
                                                                children: "Home Owners"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/school-tiles",
                                                                children: "Education"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/trulook",
                                                                children: "Home Designing Solution"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/tile-buying",
                                                                children: "Tile Buying Guide"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/blog",
                                                                children: "Inspirations for you"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/blog/web-story/",
                                                                children: "Web Stories"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/design-ideas/",
                                                                children: "Design Ideas"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/masterbond-tile-adhesive",
                                                                children: "Tile Adhesive"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col foot-connect",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[12] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(12),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Connect with us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "Social-Icons flex-class",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://wa.me/918750733333?text=",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/whatsapp.jpg",
                                                                    alt: "WhatsApp",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.instagram.com/orientbell/?hl=en",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/insta-icon.png",
                                                                    alt: "instagram",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.facebook.com/OrientBellTiles/",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/facebook.jpg",
                                                                    alt: "Facebook",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.youtube.com/@OrientBellTiles",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/youtube-icon.svg",
                                                                    alt: "youtube",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://in.pinterest.com/OrientbellTiles/",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/pinterest-icon.svg",
                                                                    alt: "pinterest",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.linkedin.com/company/orientbellltd",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/linkedIn.jpg",
                                                                    alt: "LinkedIn",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://twitter.com/OrientbellTiles",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    style: {
                                                                        background: "#e6e6e6"
                                                                    },
                                                                    width: "20px",
                                                                    src: "/icons8-x-logo.svg",
                                                                    alt: "Twitter",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "select-lang",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "P9LngDdl",
                                                            style: {
                                                                color: "#fffff1"
                                                            },
                                                            children: "Change Language"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            id: "P9LngDdl",
                                                            className: "mobilelanguga",
                                                            onChange: (e)=>{
                                                                if (e.target.value) {
                                                                    router.push(e.target.value);
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select "
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "https://orientbell.com/".concat(router.asPath),
                                                                    children: "English"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "https://hindi.orientbell.com/".concat(router.asPath),
                                                                    children: "हिंदी"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "https://tamil.orientbell.com/".concat(router.asPath),
                                                                    children: "தமிழ்"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col cpaddress",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[13] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(13),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Corporate Office"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Iris House, 16 Business Centre,Nangal Raya,",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "DDA Complex,New Delhi - 110046 (India)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "telno",
                                                    children: [
                                                        "Tel: ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:911147119100",
                                                            children: "+91-11-47119100"
                                                        }),
                                                        ", -",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:911147119200",
                                                            children: "47119200"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "telno",
                                                    children: [
                                                        "Email:",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:customercare@orientbell.com",
                                                            children: "customercare@orientbell.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: isClassToggled[14] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(14),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Policies"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/privacy-policy",
                                                                children: "Privacy Policy"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/shipping-policy",
                                                                children: "Shipping Policy"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://www.orientbell.com/return-and-refund-policy",
                                                                children: "Returns & Refund Policy"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "maplocate",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        loading: "lazy",
                                                        src: "/footer-paymet2_1_1.webp",
                                                        alt: "Image"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "footer-badge-row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "flex-class",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/media/pdf/GRIHA.pdf",
                                                                        download: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            loading: "lazy",
                                                                            src: "/GRIHA.png",
                                                                            alt: "Image"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://www.orientbell.com/quality-certificates",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/CE-11.png",
                                                                        alt: "Image"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://www.orientbell.com/quality-certificates",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/IS.png",
                                                                        alt: "Image"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://www.orientbell.com/media/pdf/Orient_Bell_Ltd.pdf",
                                                                        download: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            loading: "lazy",
                                                                            src: "/IGBC.png",
                                                                            alt: "Image"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    tarrekImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "get-in-touchpopup",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/tareek_get_in_touch.avif",
                                alt: "tareek image",
                                id: "tareeq-figurine-view",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setGetInTouch(true);
                                    settarrekImage(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon-close-black-icon",
                                id: "tareeq-figurine-view",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    settarrekImage(false);
                                    localStorage.setItem("TarikClosed", true);
                                // Push dismissal event
                                // if (typeof window !== "undefined") {
                                //   window.dataLayer = window.dataLayer || [];
                                //   window.dataLayer.push({
                                //     event: "mkt-form-view",
                                //     action: "closed",
                                //     popup_id: "tareeq-figurine-view"
                                //   });
                                // }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/close_round_icon.svg",
                                    alt: "close icon",
                                    id: "tareeq-figurine-view"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "copy-right",
                children: "Copyright \xa9 2025 OrientBell, All rights reserved."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchModal, {
                show: getInTouch,
                onHide: ()=>{
                    setTimePopup(false);
                    setGetInTouch(false);
                    localStorage.setItem("leadSkiped", true);
                },
                TimePopup: TimePopup,
                submitGetInTouch: submitGetInTouch,
                touch: touch,
                setTouch: setTouch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: LocationPopop,
                className: "pincode-popup-bx expert_assistance_modal",
                onHide: ()=>{
                    js_cookie/* default.set */.Z.set("skipLocation", true, {
                        expires: 7,
                        secure: true,
                        sameSite: "Strict"
                    });
                    js_cookie/* default.set */.Z.set("skipLocationTimeBestPrice", true, {
                        expires: 7,
                        secure: true,
                        sameSite: "Strict"
                    });
                    setleadpopop();
                    setLocationPopop(false);
                    popoptarek();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-location-popup",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Dialog */.Z.Dialog, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                                closeButton: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    class: "location-pop-section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "location-icon-bx",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/location-icon.png",
                                                alt: "location icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            class: "location-text-bx",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                                    children: "Allow Your Location to get best prices in your area"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(address/* default */.Z, {
                                    setLocationPopop: setLocationPopop,
                                    setleadpopop: setleadpopop,
                                    settarrekImage: settarrekImage
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);


/***/ }),

/***/ 17360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useCounterStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31993);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(782);


const useCounterStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)((set)=>({
        // State variables
        premiumForm: false,
        sidePromptModal: true,
        sidePromptModalClicked: false,
        _hasHydrated: false,
        sourceId: "",
        // Actions to update state variables
        setPremiumForm: (value)=>set({
                premiumForm: value
            }),
        setSidePromptModal: (value)=>set({
                sidePromptModal: value
            }),
        setSidePromptModalClicked: (value)=>set({
                sidePromptModalClicked: value
            }),
        setHasHydrated: (state)=>set({
                _hasHydrated: state
            }),
        setSourceId: (id)=>set({
                sourceId: id
            })
    }), {
    name: "counter-store",
    // variables to persist
    partialize: (state)=>({
            _hasHydrated: state._hasHydrated,
            sidePromptModalClicked: state.sidePromptModalClicked,
            sidePromptModal: state.sidePromptModal
        }),
    // Actions to run after hydration
    onRehydrateStorage: ()=>(state)=>{
            if (state) state.setHasHydrated(true);
        }
}));


/***/ })

}]);